import React from 'react';
import * as componentStyle from './caseStudyBanner.module.scss';
import { Breadcrumb } from '../../../interface/breadcrumb.interface';
import { GatsbyImageInterface } from '../../../interface/image.interface';
import NewBreadcrumbs from '../../NewBreadcrumbs/NewBreadcrumbs';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';

interface ImageInterface {
  image: GatsbyImageInterface | null;
  altText: string | null;
}
interface ContextListInterface {
  label: string | null;
  message: string | null;
}
interface ContextInterface {
  heading: string | null;
  description: string | null;
}
export interface CaseStudyBannerInterface {
  heading: string | null;
  elementImage: ImageInterface | null;
  description: string | null;
  subHeadingTwo: string | null;
  contextList: ContextListInterface[] | null;
  sectionImage: ImageInterface | null;
  context: ContextInterface[] | null;
}
interface CaseStudyBannerProps {
  breadcrumb?: Breadcrumb[] | null;
  bannerData?: CaseStudyBannerInterface | null;
}

export default function CaseStudyBanner({ data }: { data: CaseStudyBannerProps | null }) {
  return (
    <section className={componentStyle.caseStudyBanner}>
      <div className={componentStyle.caseStudyBanner__container}>
        {data?.breadcrumb && (<NewBreadcrumbs data={data?.breadcrumb} />)}
        <div className={componentStyle.caseStudyBanner__contextArea}>

          <div className={componentStyle.caseStudyBanner__headingArea}>
            <div className={componentStyle.caseStudyBanner__headingAreaLeft}>
              {data?.bannerData?.heading && <div className={componentStyle.caseStudyBanner__heading} dangerouslySetInnerHTML={{ __html: data.bannerData.heading }}></div>}
            </div>
            <div className={componentStyle.caseStudyBanner__headingAreaRight}>
              {data?.bannerData?.elementImage?.image &&
                <GatsbyImage 
                  image={getImage(data.bannerData.elementImage.image.localFile) as IGatsbyImageData} 
                  alt={data?.bannerData?.elementImage?.altText || 'N/A'} 
                />
              }
            </div>
          </div>
          
          {data?.bannerData?.description && <div className={componentStyle.caseStudyBanner__description} dangerouslySetInnerHTML={{ __html: data.bannerData.description }}></div>}

          {data?.bannerData?.subHeadingTwo && <div className={componentStyle.caseStudyBanner__subHeading} dangerouslySetInnerHTML={{ __html: data.bannerData.subHeadingTwo }}></div>}

          <ul className={componentStyle.caseStudyBanner__list}>
            {data?.bannerData?.contextList?.map((d, index) => (
              <li key={`item${index}`} className={componentStyle.caseStudyBanner__listItem}>
                <div className={componentStyle.caseStudyBanner__itemChild}>
                  {d.label && (<label className={componentStyle.caseStudyBanner__childLabel}>{d.label}</label>)}
                  {d.message && <div className={componentStyle.caseStudyBanner__childMessage} dangerouslySetInnerHTML={{__html: d.message }}></div>}
                </div>
              </li>
            ))}
          </ul>

          {data?.bannerData?.sectionImage?.image && (
            <div className={componentStyle.caseStudyBanner__sectionImage}>
              <GatsbyImage
                image={getImage(data.bannerData.sectionImage.image.localFile) as IGatsbyImageData}
                alt={data?.bannerData?.sectionImage?.altText || 'N/A'}
              />
            </div>
          )}

          <div className={componentStyle.caseStudyBanner__context}>
            {data?.bannerData?.context?.map((d, index) => (
              <div key={`item${index}`} className={componentStyle.caseStudyBanner__contextChild}>
                {d.heading && <h2 className={componentStyle.caseStudyBanner__contextLabel}>{d.heading}</h2>}
                {d.description && <div className={componentStyle.caseStudyBanner__contextDescription} dangerouslySetInnerHTML={{ __html: d.description }}></div>}
              </div>
            ))}
          </div>
  
        </div>
      </div>
    </section>
  )
}
